<template>
  <div class="h-100 d-flex align-items-center">
    <page-header remove-back-button close-button @back="exitStepper" />
    <div class="d-flex justify-content-center h-100 w-100 align-items-center" v-if="loading">
      <b-spinner type="grow" class="align-middle" variant="secondary" />
    </div>
    <div class="max-width container-fluid" v-else>
      <transition name="fade" mode="out-in">
        <div :key="currentStep">
          <component v-if="parseComponent" v-bind:is="parseComponent" :step="stepToShow" />
          <div class="row justify-content-center">
            <div class="col col-md-6 mt-4 d-flex justify-content-end">
              <b-button v-if="isLastStep" variant="secondary" @click="endStepper">
                {{ trans("stepper.buttons.done") }}
              </b-button>
              <b-button v-else variant="secondary" @click="nextStep">
                {{ trans("stepper.buttons.continue") }}
              </b-button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="w-100 d-flex align-items-center position-fixed index progress-bar">
      <page-progress v-if="!loading" :current="calculateProgress" :max="numSteps" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PageHeader from "../organisms/PageHeader";
import UserStep from "../molecules/stepper/steps/UserStep";
import SimpleStep from "../molecules/stepper/steps/SimpleStep";
import CompanyStep from "../molecules/stepper/steps/CompanyStep";
import PageProgress from "../molecules/PageProgress";

export default {
  name: "StepperStory",
  components: { PageHeader, UserStep, SimpleStep, CompanyStep, PageProgress },
  data() {
    return {
      stepperId: 0,
      stepper: [],
      currentStep: 0,
      loading: true,
    };
  },
  methods: {
    ...mapActions({
      registerStatus: "stepper/registerStatus",
    }),
    async fetchStepper() {
      return this.$axios
        .get(`/api/rest/stepper/${this.stepperId}`)
        .then((res) => {
          this.stepper = res.data.steps;

          this.loading = false;
        })
        .catch((err) => console.log(err));
    },

    async nextStep() {
      this.trackMixPanel("Continue", false);
      this.currentStep++;
    },
    endStepper() {
      //set the Introduction as Done
      this.registerStatus({ stepperId: this.stepperId, stepper: "introduction", status: "done" });

      this.trackMixPanel("Continue", true);

      this.redirectStepper();
    },
    exitStepper() {
      //set the Introduction as Skipped
      this.registerStatus({
        stepperId: this.stepperId,
        stepper: "introduction",
        status: "skipped",
      });

      this.trackMixPanel("Close", false);

      this.redirectStepper();
    },
    redirectStepper() {
      if (this.activeServices) {
        this.$router.push({ name: "servicedashboard" }).catch(() => {});
      } else {
        this.$router.push({ name: "serviceListPage" }).catch(() => {});
      }
    },
    trackMixPanel(action, last) {
      trackEvent(`Stepper${action}`, {
        stepperId: this.stepperId,
        stepNumber: this.currentStep + 1,
        last: last,
      });
    },
  },
  computed: {
    ...mapGetters({
      activeServices: "user/getUserActiveServices",
    }),
    stepToShow() {
      return this.stepper[this.currentStep];
    },
    calculateProgress() {
      return this.currentStep + 1;
    },
    numSteps() {
      return this.stepper.length;
    },
    isLastStep() {
      return this.numSteps === this.calculateProgress;
    },
    parseComponent() {
      let component = this.stepToShow["__component"].replace("steps.", "");
      switch (component) {
        case "user-step":
        case "simple-step":
        case "company-step":
          return component;
        default:
          return "";
      }
    },
  },
  async mounted() {
    Intercom("update", {
      hide_default_launcher: true,
    });

    this.stepperId = Number(this.$route.params.stepperId);

    await this.fetchStepper();
  },
};
</script>

<style scoped lang="scss">
.progress-bar {
  background-color: $color-white;
  bottom: 0;
  left: 0;
}
.index {
  z-index: 999;
}

.fade-enter,
.fade-enter-active,
.fade-leave,
.fade-leave-active,
.fade-leave-to {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
